import { render, staticRenderFns } from "./BtnMovimientosEntreCajas.vue?vue&type=template&id=3ce5c556&"
import script from "./BtnMovimientosEntreCajas.vue?vue&type=script&lang=js&"
export * from "./BtnMovimientosEntreCajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports